export const samplesAndTypes = ['name', 'description', 'isRequiredInTemplate'];
export const attachmentTypes = ['name', 'description', 'isRequiredInTemplate'];
export const certifications = ['name', 'description', 'isRequiredInTemplate'];
export const industries = ['industryNumber', 'industryName', 'addressLine1', 'classification'];
export const templates = ['name', 'description', 'effectiveDateTimeLocal'];
export const parameterGroupColumns = ['name', 'description', 'isActive'];
